import React, { useState, useEffect } from 'react';
import styles from './AutocompleteInput.module.css';

const AutocompleteInput = ({ exerciseTypes, index, field, handleInputChange, value }) => {
    const inputValue = value ?? '';
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [isListVisible, setIsListVisible] = useState(false);

    useEffect(() => {
        if (inputValue) {
            const filtered = exerciseTypes.filter(exercise =>
                exercise.exerciseType.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredSuggestions(filtered);

            const hasExact = filtered.some(
                e => e.exerciseType.toLowerCase() === inputValue.toLowerCase()
            );

            setIsListVisible(filtered.length > 0 && !hasExact);
        } else {
            setFilteredSuggestions([]);
            setIsListVisible(false);
        }
    }, [inputValue, exerciseTypes]);

    const handleChange = (e) => {
        handleInputChange(index, field, e.target.value);
    };

    const handleSuggestionClick = (suggestion) => {
        // Update parent; parent value flows back into inputValue
        handleInputChange(index, field, suggestion.exerciseType);
        setFilteredSuggestions([]);
        setIsListVisible(false);
    };

    const handleBlur = () => {
        setIsListVisible(false);
    };

    const handleFocus = () => {
        if (filteredSuggestions.length > 0) {
            const hasExact = filteredSuggestions.some(
                (exercise) => exercise.exerciseType.toLowerCase() === inputValue.toLowerCase()
            );

            setIsListVisible(!hasExact);
        }
    };

    return (
        <div className={styles.inputWrapper}>
            <input
                type="text"
                className={styles.input}
                value={inputValue}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                placeholder="Category"
            />
            {isListVisible && filteredSuggestions.length > 0 && (
                <ul className={styles.suggestionsList}>
                    {filteredSuggestions.map((suggestion) => (
                        <li
                            key={suggestion.id}
                            className={styles.suggestionItem}
                            onMouseDown={() => handleSuggestionClick(suggestion)}
                        >
                            {suggestion.exerciseType}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};


export default AutocompleteInput;
